import React from 'react';
import { translate } from '../../Common';
import { FaUser, FaTruck, FaUserShield, FaRegBuilding } from 'react-icons/fa';
import { BiPackage } from 'react-icons/bi';

/**
 * Obtiene la información del rol de confianza del cliente (IdConfRoles)
 * @param {number} roleId - ID del rol (1: customer, 2: delivery agent, 3: admin)
 * @param {number} iconSize - Tamaño del icono (por defecto 14)
 * @returns {object} Objeto con { label, icon }
 */
export const getClientConfRoleInfo = (roleId, iconSize = 14) => {
  const roleConfig = {
    1: {
      label: translate('dashboard.companies.detail.clients.roles.customer'),
      icon: React.createElement(FaUser, { size: iconSize })
    },
    2: {
      label: translate('dashboard.companies.detail.clients.roles.deliveryAgent'),
      icon: React.createElement(FaTruck, { size: iconSize })
    },
    3: {
      label: translate('dashboard.companies.detail.clients.roles.admin'),
      icon: React.createElement(FaUserShield, { size: iconSize })
    }
  };

  return roleConfig[roleId] || { label: '-', icon: null };
};

/**
 * Obtiene la información del tipo de cliente (IdTipoCliente)
 * @param {number} clientTypeId - ID del tipo de cliente (1: package, 7: BLI)
 * @param {number} iconSize - Tamaño del icono (por defecto 14)
 * @returns {object} Objeto con { label, icon, variant }
 */
export const getClientTypeInfo = (clientTypeId, iconSize = 14) => {
  const clientTypeConfig = {
    1: {
      label: translate('global.package'),
      icon: React.createElement(BiPackage, { size: iconSize }),
      variant: 'info'
    },
    7: {
      label: translate('global.BLI'),
      icon: React.createElement(FaRegBuilding, { size: iconSize }),
      variant: 'error'
    }
  };

  const config = clientTypeConfig[clientTypeId] || { label: '-', icon: null, variant: 'neutral' };
  
  // Capitalizar la primera letra del label
  if (config.label && config.label !== '-') {
    config.label = config.label.charAt(0).toUpperCase() + config.label.slice(1);
  }
  
  return config;
};

